import { useNavigate } from "react-router-dom";
import "./SubscriptionBanner.css";
import { trackEvent } from "../../../../config/analytics";
const SubscriptionBanner = () => {
  const navigate = useNavigate();

  const handleSubscribeClick = () => {
     trackEvent("signup_form_opened");
    navigate("/subscribe");
  };

  return (
    <section className="subscription-banner">
      <div className="subscription-banner-content">
        <span className="subscription-banner-badge">
          <b>New</b>
        </span>

        <span className="subscription-banner-text">
           EvoNext RegPulse Email Digest: Curated regulatory intelligence with AI-powered insights, delivered to your inbox
        </span>

        <button
          type="button"
          className="subscription-banner-btn"
          onClick={handleSubscribeClick}
          
        >
          <b>Subscribe - it's free</b>
        </button>
      </div>
    </section>
  );
};

export default SubscriptionBanner;